/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import { customInstance } from '../../../customInstance'
import type { ErrorType } from '../../../customInstance'
import type {
    DeleteRequestOptionsByNameParams,
    GetRequestOptionsByName200,
    GetRequestOptionsByNameParams,
    GetRequestOptionsParams,
    HTTPValidationErrorDTO,
    PutRequestOptionsByNameParams,
} from '../../model'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * this will list up the options available for a user

 * @summary Get Option Names
 */
export const getRequestOptions = (
    params: GetRequestOptionsParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<string[]>({ url: `/options`, method: 'GET', params, signal }, options)
}

export const getGetRequestOptionsQueryKey = (params?: GetRequestOptionsParams) => {
    return [`/options`, ...(params ? [params] : [])] as const
}

export const getGetRequestOptionsQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestOptions>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestOptionsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestOptions>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetRequestOptionsQueryKey(params)

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestOptions>>> = ({ signal }) =>
        getRequestOptions(params, requestOptions, signal)

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestOptions>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestOptionsQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestOptions>>
>
export type GetRequestOptionsQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestOptions<
    TData = Awaited<ReturnType<typeof getRequestOptions>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestOptionsParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestOptions>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestOptions>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestOptions>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestOptions<
    TData = Awaited<ReturnType<typeof getRequestOptions>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestOptionsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestOptions>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestOptions>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestOptions>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestOptions<
    TData = Awaited<ReturnType<typeof getRequestOptions>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestOptionsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestOptions>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Option Names
 */

export function useGetRequestOptions<
    TData = Awaited<ReturnType<typeof getRequestOptions>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    params: GetRequestOptionsParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestOptions>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestOptionsQueryOptions(params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * this call returns the option_value for a the given option and user

 * @summary Get Option
 */
export const getRequestOptionsByName = (
    name: string,
    params: GetRequestOptionsByNameParams,
    options?: SecondParameter<typeof customInstance>,
    signal?: AbortSignal,
) => {
    return customInstance<GetRequestOptionsByName200>(
        { url: `/options/${encodeURIComponent(String(name))}`, method: 'GET', params, signal },
        options,
    )
}

export const getGetRequestOptionsByNameQueryKey = (
    name?: string,
    params?: GetRequestOptionsByNameParams,
) => {
    return [`/options/${name}`, ...(params ? [params] : [])] as const
}

export const getGetRequestOptionsByNameQueryOptions = <
    TData = Awaited<ReturnType<typeof getRequestOptionsByName>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    name: string,
    params: GetRequestOptionsByNameParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestOptionsByName>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetRequestOptionsByNameQueryKey(name, params)

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRequestOptionsByName>>> = ({
        signal,
    }) => getRequestOptionsByName(name, params, requestOptions, signal)

    return { queryKey, queryFn, enabled: !!name, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof getRequestOptionsByName>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRequestOptionsByNameQueryResult = NonNullable<
    Awaited<ReturnType<typeof getRequestOptionsByName>>
>
export type GetRequestOptionsByNameQueryError = ErrorType<HTTPValidationErrorDTO>

export function useGetRequestOptionsByName<
    TData = Awaited<ReturnType<typeof getRequestOptionsByName>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    name: string,
    params: GetRequestOptionsByNameParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestOptionsByName>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestOptionsByName>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestOptionsByName>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestOptionsByName<
    TData = Awaited<ReturnType<typeof getRequestOptionsByName>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    name: string,
    params: GetRequestOptionsByNameParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestOptionsByName>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getRequestOptionsByName>>,
                    TError,
                    Awaited<ReturnType<typeof getRequestOptionsByName>>
                >,
                'initialData'
            >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRequestOptionsByName<
    TData = Awaited<ReturnType<typeof getRequestOptionsByName>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    name: string,
    params: GetRequestOptionsByNameParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestOptionsByName>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Option
 */

export function useGetRequestOptionsByName<
    TData = Awaited<ReturnType<typeof getRequestOptionsByName>>,
    TError = ErrorType<HTTPValidationErrorDTO>,
>(
    name: string,
    params: GetRequestOptionsByNameParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof getRequestOptionsByName>>, TError, TData>
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getGetRequestOptionsByNameQueryOptions(name, params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>
    }

    query.queryKey = queryOptions.queryKey

    return query
}

/**
 * this call deletes an option for a user
 * @summary Delete Option
 */
export const deleteRequestOptionsByName = (
    name: string,
    params: DeleteRequestOptionsByNameParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<unknown>(
        { url: `/options/${encodeURIComponent(String(name))}`, method: 'DELETE', params },
        options,
    )
}

export const getDeleteRequestOptionsByNameMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof deleteRequestOptionsByName>>,
        TError,
        { name: string; params: DeleteRequestOptionsByNameParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof deleteRequestOptionsByName>>,
    TError,
    { name: string; params: DeleteRequestOptionsByNameParams },
    TContext
> => {
    const mutationKey = ['deleteRequestOptionsByName']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof deleteRequestOptionsByName>>,
        { name: string; params: DeleteRequestOptionsByNameParams }
    > = (props) => {
        const { name, params } = props ?? {}

        return deleteRequestOptionsByName(name, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type DeleteRequestOptionsByNameMutationResult = NonNullable<
    Awaited<ReturnType<typeof deleteRequestOptionsByName>>
>

export type DeleteRequestOptionsByNameMutationError = ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Delete Option
 */
export const useDeleteRequestOptionsByName = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof deleteRequestOptionsByName>>,
            TError,
            { name: string; params: DeleteRequestOptionsByNameParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof deleteRequestOptionsByName>>,
    TError,
    { name: string; params: DeleteRequestOptionsByNameParams },
    TContext
> => {
    const mutationOptions = getDeleteRequestOptionsByNameMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
/**
 * this call updates if exists or inserts a new options for a user

 * @summary Put Option
 */
export const putRequestOptionsByName = (
    name: string,
    params: PutRequestOptionsByNameParams,
    options?: SecondParameter<typeof customInstance>,
) => {
    return customInstance<unknown>(
        { url: `/options/${encodeURIComponent(String(name))}`, method: 'PUT', params },
        options,
    )
}

export const getPutRequestOptionsByNameMutationOptions = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof putRequestOptionsByName>>,
        TError,
        { name: string; params: PutRequestOptionsByNameParams },
        TContext
    >
    request?: SecondParameter<typeof customInstance>
}): UseMutationOptions<
    Awaited<ReturnType<typeof putRequestOptionsByName>>,
    TError,
    { name: string; params: PutRequestOptionsByNameParams },
    TContext
> => {
    const mutationKey = ['putRequestOptionsByName']
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined }

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof putRequestOptionsByName>>,
        { name: string; params: PutRequestOptionsByNameParams }
    > = (props) => {
        const { name, params } = props ?? {}

        return putRequestOptionsByName(name, params, requestOptions)
    }

    return { mutationFn, ...mutationOptions }
}

export type PutRequestOptionsByNameMutationResult = NonNullable<
    Awaited<ReturnType<typeof putRequestOptionsByName>>
>

export type PutRequestOptionsByNameMutationError = ErrorType<HTTPValidationErrorDTO>

/**
 * @summary Put Option
 */
export const usePutRequestOptionsByName = <
    TError = ErrorType<HTTPValidationErrorDTO>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof putRequestOptionsByName>>,
            TError,
            { name: string; params: PutRequestOptionsByNameParams },
            TContext
        >
        request?: SecondParameter<typeof customInstance>
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<typeof putRequestOptionsByName>>,
    TError,
    { name: string; params: PutRequestOptionsByNameParams },
    TContext
> => {
    const mutationOptions = getPutRequestOptionsByNameMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}
